import React from "react";
import { Image, ImageProps } from "react-bootstrap";
import ImageGem from "../../images/gem.svg";

export default function Gem({ ...props }: Omit<ImageProps, "src" | "alt">) {
  return (
    <Image src={ImageGem} alt="Gem" {...props} />
  );
}
